import * as ReactDOM from 'react-dom';
import { SXSV2_CONTAINER_ID } from '../store/schema/SxSStore';

export default function removeSxSViewFromDOM(targetWindow: Window) {
    const owaSxSV2Container = targetWindow?.document?.getElementById(SXSV2_CONTAINER_ID);
    if (owaSxSV2Container) {
        ReactDOM.unmountComponentAtNode(owaSxSV2Container);
        if (owaSxSV2Container.parentNode) {
            owaSxSV2Container.parentNode.removeChild(owaSxSV2Container);
        }
    }
}
